import { localStorageUtility } from '../../utils/utilityFunctions';

function checkRole(permission_name) {
  const get_data = localStorageUtility.fetch('identity');
  let isPermited = false;
  if (get_data && get_data.permissions) {
    isPermited = get_data.permissions.includes(permission_name);
  }
  return isPermited;
}

export { checkRole };
